import { Spread } from 'editor/src/store/design/types';

/**
 * Whether a layout owns the picklist: the count is read from its options' positions and the
 * product picklists pair their options by position, so their option lists are not for editing.
 */
function isSlotLayoutCondition(spread: Pick<Spread, 'slotLayouts'> | undefined, conditionId: string): boolean {
  return !!spread?.slotLayouts?.some(
    (layout) => layout.conditionId === conditionId || layout.productConditionIds.includes(conditionId),
  );
}

export default isSlotLayoutCondition;
